import { useEffect, useState } from 'react';

import {
  ConsentLevel,
  getConsentLevel,
  hasSetConsent,
  updateConsentLevel,
} from 'src/consent';

export function useCookies(): [
  boolean,
  (level: ConsentLevel) => void,
  () => void,
] {
  const [accepted, setAccepted] = useState(hasSetConsent());

  useEffect(() => {
    const currentConsentLevel = getConsentLevel();
    if (currentConsentLevel === ConsentLevel.ALL) {
      setAccepted(true);
    }
  }, []);

  // Add experiment-id here if you want to track subscription status as part of an experiment
  // useEffect(() => {
  //   if (accepted && user) {
  //     void getAppliedExperimentVariant(
  //       'test-experiment',
  //       user.sub
  //     );
  //   }
  // }, [accepted, user]);

  const accept = (level: ConsentLevel) => {
    setAccepted(true);
    updateConsentLevel(level);
  };

  const reject = () => {
    setAccepted(false);
    updateConsentLevel(ConsentLevel.NECESSARY);
  };

  return [accepted, accept, reject];
}
